module.exports = __webpack_public_path__ + "media/scholarship_winners/josh-w-24a8a7ca.png";